<template>
  <div class="content">
    <section
      class="cropper-area"
    >
      <Cropper
        ref="cropper"
        class="cropper"
        :src="inputImageUrl"
        :debounce="false"
        :stencil-props="{
          aspectRatio: localAspectRatioNumber
        }"
        @change="onChange"
      />
      <v-switch
          v-model="customAspectRation"
          label="Custom aspect ratio"
      ></v-switch>
    </section>
    <section
        class="preview-area"
      >
        <p>Preview</p>
          <preview
            v-if="result.coordinates"
            :width="previewWidth"
            :height="previewWidth / (result.coordinates.width / result.coordinates.height)"
            :image="result.image"
            :coordinates="result.coordinates"
          />
        <p>Cropped Image</p>
        <div class="cropped-image">
          <img
            v-if="croppedImage"
            :src="croppedImage"
            :width="previewWidth"
            alt="Cropped Image"
          />
          <div v-else class="crop-placeholder" />
        </div>
      </section>
  </div>
</template>

<script>
import { Cropper, Preview } from 'vue-advanced-cropper';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'CropperWrapper',
  components: {
    Cropper,
    Preview,
  },

  props: {
    mode: {
      type: String,
      default: 'simple',
    },

    aspectRatio: {
      type: String,
      default: 'vertical',
    },

    inputImageUrl: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    data: null,
    croppedImage: '',
    localAspectRatio: '',
    isCropDisabled: false,
    result: {
      coordinates: null,
      image: null,
    },
    customAspectRation: false,
  }),

  created() {
    this.localAspectRatio = this.aspectRatio;
  },

  methods: {
    cropImage() {
      if (this.isCropDisabled) {
        return false;
      }

      const { canvas } = this.$refs.cropper.getResult();

      this.isCropDisabled = true;

      this.croppedImage = canvas.toDataURL();
      this.$emit('cropped', this.croppedImage);

      this.isCropDisabled = false;

      return false;
    },

    destroyed() {
      // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
      if (this.image.src) {
        URL.revokeObjectURL(this.inputImageUrl);
      }
    },

    onChange({ coordinates, image }) {
      this.result = {
        coordinates,
        image,
      };
    },
  },

  computed: {
    localAspectRatioNumber() {
      if (this.customAspectRation) {
        return null;
      }

      switch (this.localAspectRatio) {
        case 'vertical':
          return 9 / 16;
        case 'horizontal':
        default:
          return 16 / 9;
      }
    },

    previewWidth() {
      return this.localAspectRatioNumber > 1 ? 300 : 200;
    },
  },

};
</script>

<style scoped>

.cropper {
  max-width: 614px;
}

.content {
  display: flex;
  justify-content: space-between;
}

.cropper-area {
  max-width: 614px;
}

.preview-area {
  width: 307px;
}
</style>
